import { Flex, Text, Checkbox, Tooltip, Box, HStack } from "@chakra-ui/react";
import { useAppContext } from "../AppContext";
import { QuestionIcon } from "@chakra-ui/icons";
import { useState } from "react";

export const CopyWithVerseCheckBox = (): JSX.Element => {
  const { copyWithVerse, setCopyWithVerse, isEnglish } = useAppContext();
  const [isToolTipOpen, setIsToolTipOpen] = useState<boolean>(false);
  const tooltipText = isEnglish ? "Add the source of the scripture when copying" : "複製時加上經文出處";

  return (
    <Flex align="center" justify="space-between">
      <Tooltip label={tooltipText} placement="top" isOpen={isToolTipOpen}>
        <HStack onClick={() => setIsToolTipOpen(!isToolTipOpen)} spacing={"4px"}>
          <Text fontSize="lg" as="b">
            {isEnglish ? `Copy w/ source` : `複製經文出處`}
          </Text>
          <Box
            cursor="pointer" // Adds a pointer cursor to indicate it's clickable
            _hover={{ color: "blue.500" }} // Optional: Changes color on hover for better UX
            w="16px"
          >
            <QuestionIcon />
          </Box>
          <Text fontSize="lg" as="b">
            :
          </Text>
        </HStack>
      </Tooltip>
      <Flex gap={"10px"}>
        <HStack alignContent={"left"} w={"110px"} mt="2px">
          <Checkbox size="lg" isChecked={copyWithVerse} onChange={() => setCopyWithVerse(!copyWithVerse)} />
        </HStack>
      </Flex>
    </Flex>
  );
};
